
"use client";

import Navigation from '@/components/Navigation';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Sparkles, FileText, Search, Calendar, ChevronLeft, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useState } from 'react';

const MOCK_REPORTS = [
  { id: '1', type: 'diagnosis', title: 'صوت صرير في المحرك', date: '2024-05-20', status: 'completed' },
  { id: '2', type: 'vin', title: 'تقرير تويوتا كامري 2023', date: '2024-05-18', status: 'completed' },
  { id: '3', type: 'diagnosis', title: 'تهريب زيت أسفل السيارة', date: '2024-05-15', status: 'completed' },
];

export default function ReportsPage() {
  const [reports, setReports] = useState(MOCK_REPORTS);

  const deleteReport = (id: string) => {
    setReports(reports.filter(r => r.id !== id));
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Navigation title="سجل التقارير والفحوصات" />
      
      <div className="p-4 max-w-2xl mx-auto space-y-4">
        <div className="bg-white p-6 rounded-[2rem] shadow-sm mb-6 border-none">
          <div className="flex items-center gap-3 mb-2">
            <div className="bg-indigo-100 p-2 rounded-xl text-indigo-600">
              <FileText className="h-5 w-5" />
            </div>
            <h2 className="text-lg font-bold">كراجك الذكي</h2>
          </div>
          <p className="text-xs text-slate-400">هنا تجد جميع الفحوصات والتقارير التي قمت بحفظها مسبقاً.</p>
        </div>

        <div className="space-y-3">
          {reports.length === 0 ? (
            <div className="text-center py-20">
              <FileText className="h-16 w-16 text-slate-200 mx-auto mb-4" />
              <p className="text-slate-400 font-bold">لا توجد تقارير محفوظة حالياً.</p>
            </div>
          ) : (
            reports.map((report) => (
              <Card key={report.id} className="border-none shadow-sm rounded-3xl overflow-hidden bg-white hover:shadow-md transition-shadow group">
                <CardContent className="p-4 flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className={`p-3 rounded-2xl ${report.type === 'diagnosis' ? 'bg-indigo-50 text-indigo-600' : 'bg-orange-50 text-orange-600'}`}>
                      {report.type === 'diagnosis' ? <Sparkles className="h-6 w-6" /> : <Search className="h-6 w-6" />}
                    </div>
                    <div>
                      <h3 className="font-bold text-sm text-slate-800 mb-1">{report.title}</h3>
                      <div className="flex items-center gap-2 text-[10px] text-slate-400">
                        <Calendar className="h-3 w-3" />
                        <span>{report.date}</span>
                        <Badge variant="secondary" className="bg-slate-50 text-[8px] h-4 px-1">{report.type === 'diagnosis' ? 'تشخيص ذكي' : 'تقرير VIN'}</Badge>
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex items-center gap-2">
                    <Button variant="ghost" size="icon" className="rounded-full h-10 w-10 text-slate-300 hover:text-red-500 hover:bg-red-50" onClick={() => deleteReport(report.id)}>
                      <Trash2 className="h-5 w-5" />
                    </Button>
                    <Button variant="ghost" size="icon" className="rounded-full h-10 w-10 text-slate-300 hover:bg-slate-50">
                      <ChevronLeft className="h-5 w-5" />
                    </Button>
                  </div>
                </CardContent>
              </Card>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
